// extracted by mini-css-extract-plugin
export default {"table":"styles_table__C6zlj","cell":"styles_cell__NneBD"};